import classnames from 'classnames';
import React, { ChangeEvent, useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import FormLabel from '../FormLabel/FormLabel';
import styles from './select.module.scss';

interface InputProps extends React.InputHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: {
    label: string;
    value: string | number;
    disabled?: boolean;
    hidden?: boolean;
  }[];
  error?: string | null;
  register: UseFormRegisterReturn;
  className?: string;
  hasValue?: boolean;
}

const Select = ({
  label,
  error,
  register,
  className,
  required,
  options,
  hasValue,
  ...selectProps
}: InputProps) => {
  const [hasSelectedValue, setHasSelectedValue] = useState(hasValue);

  const { onChange, ...registerProps } = register;
  const _onChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(e);
    setHasSelectedValue(!!e.currentTarget.value);
  };

  return (
    <div className={classnames(className)}>
      {label ? (
        <FormLabel label={label} required={required} error={error} />
      ) : null}
      <select
        {...registerProps}
        onChange={_onChange}
        className={classnames('form-control', styles.select, {
          'text-light3': !hasSelectedValue,
        })}
        {...selectProps}
        aria-label={register.name}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
            hidden={option.hidden}
            className="text-dark-light"
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
